import { Http } from "@Services";
import { ITextFieldSubmission } from "@Interfaces";

export interface GetTextFieldResponsesResponse {
    success: boolean;
    data: ITextFieldSubmission[];
}

/**
 * Fetch submitted responses for a specific text field.
 * Only callable by authenticated users (field creators).
 *
 * @param textFieldId - The ID of the text field
 * @param skip - Number of responses to skip (for pagination)
 * @param limit - Maximum number of responses to fetch
 * @returns Promise with list of submitted responses
 * @throws Error if the API request fails
 */
export const getTextFieldResponses = async (
    textFieldId: string,
    skip = 0,
    limit = 50
): Promise<GetTextFieldResponsesResponse> => {
    try {
        const response = await Http.Request<GetTextFieldResponsesResponse>({
            method: "GET",
            url: `/poll-text-fields/${textFieldId}/submissions?skip=${skip}&limit=${limit}`,
        });

        if (!response?.data) {
            throw new Error("Invalid response format from server");
        }

        return response;
    } catch (error) {
        console.error("Failed to fetch text field responses:", error);
        throw error;
    }
};
